<div class="d-flex justify-content-center align-items-center" style="min-height: 400px;">
  <div class="card loginformwidth">
    <div class="card-body">
      <a (click)="onBack()" href="javascript:void(0)" class="mb-2 d-inline-block">
        <i data-feather="chevron-left" class="mb-25"></i> Go back to Log in
      </a>
      <h3 class="font-weight-bolder mb-1">Recover Username</h3>
      <p>We will send you an sms to this phone number to help you remember your username.</p>
      <form [formGroup]="teacherForgotUsernameForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label>Phone number</label>
          <input class="form-control" formControlName="phone" placeholder="0700000000" />
          <div
            *ngIf="teacherForgotUsernameForm.get('phone').invalid && (teacherForgotUsernameForm.get('phone').dirty || teacherForgotUsernameForm.get('phone').touched)"
            class="text-danger"
          >
            Enter a valid phone number
          </div>
        </div>
        <div *ngIf="teacherForgotUsernameError" class="alert alert-danger">{{ teacherForgotUsernameError }}</div>
        <div *ngIf="teacherForgotUsernameSuccess" class="alert alert-success">{{ teacherForgotUsernameSuccess }}</div>
        <button class="btn btn-primary btn-block" [disabled]="teacherForgotUsernameForm.invalid || loading">
          Send SMS
        </button>
      </form>
    </div>
  </div>
</div>
